{
  "title": "How to Find and Manage Submissions",
  "description": "Query, filter, and review each team's submission status on the submissions management page.",
  "headings": [
    "What You'll Accomplish",
    "Applies To",
    "Before You Start",
    "Steps",
    "What You'll See",
    "FAQ"
  ],
  "summary": "When you're done, you'll have a clear view of every team's submission progress, and can lock, unlock, or withdraw a submission as needed.",
  "roleNote": "Competition Admin / staff with submission.read.all",
  "prerequisites": [
    "The competition has been created",
    "At least one team has started filling out the submission form"
  ],
  "pathLabel": "Organizer Dashboard → My Competition → Submissions",
  "steps": [
    {
      "title": "1. Open Submissions",
      "description": "From the competition, open \"Submissions\"; this page requires submission.read.all permission."
    },
    {
      "title": "2. Filter the submission list",
      "description": "The submission list supports filtering by status (draft / ready / submitted / locked / withdrawn / disqualified), filtering by round (preliminary/final), filtering by category, and text search by team ID, with pagination; the table shows team, round, category, status, and submission time in order (a team's preliminary and final submissions each get their own row; the final one never replaces the preliminary one)."
    },
    {
      "title": "3. View submission details",
      "description": "Opening any submission shows its status badge, submission time, and team name, along with every uploaded file and the participant's form answers; files each offer \"Preview\" and \"Download\"."
    },
    {
      "title": "4. Take a status action if needed",
      "description": "If you have submission.manage permission, the submission detail page shows matching action buttons: \"Lock\" for a submitted submission; \"Unlock\" (returns it to editable, no notification email) or \"Withdraw\" or \"Disqualify\" for a submitted or locked submission; or \"Return for Correction\" (emails the team and requires a reason)."
    }
  ],
  "afterward": [
    "The submission list reflects your latest filters",
    "The submission detail page shows a full, read-only version history",
    "If you also have score.read or score.manage permission, the same page shows each judge's score"
  ],
  "nextSteps": "Once you've confirmed submission status, go to \"Judge Invitations & Assignments\" to assign submissions to judges, or adjust individual submissions' status as needed.",
  "faq": [
    {
      "q": "Why can't I see some of the action buttons?",
      "a": "Submission status actions (lock/unlock/withdraw/disqualify/return for correction) require submission.manage permission; with only submission.read.all, you can query and view but won't see these action buttons."
    },
    {
      "q": "What's the difference between \"Return for Correction\" and \"Unlock\"?",
      "a": "Both return the submission to an editable state. The difference is that \"Return for Correction\" is deliberately intended for communicating with the team: it requires a reason and sends an email to the team's non-teacher members explaining what needs to change; \"Unlock\" sends no notification."
    }
  ]
}
